<template>
  <div style="max-width: 60px;">
    <input 
      ref="editor"
      v-if="editMode" 
      v-model="editedVal" 
      :class="isCorrectNumber ? '' : 'error'"
      @blur="saveValue()"
      style="width: 80px;"
    >
    <div style="cursor: pointer; min-width: 100px;" v-else @click="activateEditMode()">{{ numberVal }}</div>
  </div>
</template>

<script>
export default {
  name: 'number-field',
  
  props: {
    value: {
      type: [Number, String],
      required: true
    },
    accuracy: Number
  },

  data() {
    return {
      editMode: false,
      numberVal: this.accuracy ? Number(this.value).toFixed(this.accuracy) : Number(this.value),
      editedVal: this.value
    }
  },

  methods: {
    activateEditMode() {
      this.editMode = true; 
      this.$nextTick(() => this.$refs.editor.focus());
    },
    saveValue() {
      if (this.isCorrectNumber) {
        this.editMode = false;
        if (this.accuracy) {
          this.numberVal = Number(this.editedVal).toFixed(this.accuracy);
        } else {
          this.numberVal = this.editedVal;
        }
        this.editedVal = this.numberVal;
        this.$emit('changed', Number(this.numberVal));
      }
    }
  },

  watch: {
    value(val) {
      this.editMode = false;
      this.numberVal = this.accuracy ? val.toFixed(this.accuracy) : val;
      this.editedVal = val;
    }
  },

  computed: {
    isCorrectNumber() {
      return this.isNumber(this.editedVal);
    }
  }
}
</script>